new nc.promokit.Preloader({
    'delay':600,
    'image':[
        '/promo/bns/history/2018/180307_flowerofpeak/img/main_tit1_1.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/main_tit1_2.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/main_tit_etc.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/main_stit1.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/main_stit2.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/logo.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/footer_bg.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/btn_play.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/btn_oneday_bg.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/btn_home_bg.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect1.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect2.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect3.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect4.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect5.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect6.png',
        '/promo/bns/history/2018/180307_flowerofpeak/img/tit_effect7.png'
    ],
    'video':[
        'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_intro.mp4'
    ],
    'youtbue':["6KeMAEKWyhc"]
});

$(document).on('preloadend', function(){
    setTimeout(function(){
        FLOWEROFPEAK.init();
    }, 600);
});

var FLOWEROFPEAK = (function (window, document, $, undefined) {

    var player1 = new nc.promokit.Player({
        selector: '#teaserMovie',
        videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_intro.mp4',
        mute:true,
        autoPlay:true,
        controls:false,
        coverClick:false,
        loop:true
    });

    // var layerMovie = new nc.promokit.Player({    3/16(금) 오픈
    //     selector: '#movieBox',
    //     videoId: '6KeMAEKWyhc',
    //     mute:false,
    //     controls:false,
    //     coverClick:false,
    //     loop:true
    // });

    var tEffect = new TimelineMax({paused:true}),
        petalTween1 = new TimelineMax({paused:true, repeat:-1, repeatDelay:-0.2}),
        petalTween2 = new TimelineMax({paused:true, repeat:-1, repeatDelay:-0.2});

    var init = function() {
        teaserMotion();
        petalAnimat1();
        petalAnimat2();
        tEffect.play();

        $(".container").stop().animate({opacity:1});

        $(".btn_play").on("click", function(){
            movieLayer("open");
        });

        $(".movie_close").on("click", function(){
            movieLayer("close");
        });
    };

    function teaserMotion(){
        tEffect.from($(".main_tit_etc"), 0.6, {y:60, alpha:0, ease:Circ.easeOut}, "+=0.3")
        .from($(".main_tit1_1"), 0.6, {x:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .from($(".main_tit1_2"), 0.6, {x:-80, alpha:0, ease:Power1.easeOut}, "-=0.6")
        // .from($(".btn_play"), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")    3/16(금) 오픈
        .from($(".main_stit1"), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")    // -=0.36 | 3/16(금) 오픈
        .from($(".main_stit2"), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .staggerFrom([
            $("h1>.tit_effect1"),
            $("h1>.tit_effect2"),
            $("h1>.tit_effect3"),
            $("h1>.tit_effect4"),
            $("h1>.tit_effect5"),
            $("h1>.tit_effect6"),
            $("h1>.tit_effect7")
        ], 1.1, {x:-60, alpha:0, ease:Power1.easeOut}, 0.09, "-=0.15");
    }

    function movieLayer(stateChk){
        if(stateChk=="open"){
            layerMovie.play();
            player1.pause();
            $(".layer_movie").fadeIn();
            $(window).trigger('resize');
        }else if(stateChk=="close"){
            layerMovie.stop();
            player1.play();
            $(".layer_movie").fadeOut();
        }
    }

    function petalAnimat1(){
        var bezierPath = [{x:0, y:-150, alpha:0}, {x:100, y:0, alpha:1}, {x:20, y:100, alpha:1}, {x:200, y:200, alpha:1}, {x:0, y:300, alpha:0}];
        petalTween1.to([$(".tit_effect1")], 4.3, { bezier: {type:"soft", values:bezierPath}})
        .to([$(".tit_effect3")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "-=4.0")
        .to([$(".tit_effect5")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "-=4.0")
        .to([$(".tit_effect7")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "-=4.0");
    }

    function petalAnimat2(){
        var bezierPath = [{x:0, y:-150, alpha:0}, {x:-100, y:0, alpha:1}, {x:-20, y:100, alpha:1}, {x:-200, y:200, alpha:1}, {x:0, y:300, alpha:0}];
        petalTween2.to([$(".tit_effect2")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "+=0.5")
        .to([$(".tit_effect4")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "-=4.0")
        .to([$(".tit_effect6")], 4.3, { bezier: {type:"soft", values:bezierPath}}, "-=4.0");
    }

    function complete(){
        // petalTween1.play();
        // petalTween2.play();
    }

    return {
        init:init
    };

})(window, document, $);